import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Tooltip from "@mui/material/Tooltip";

interface TokenModalProps {
  open: boolean;
  onClose: () => void;
  token: string;
  onCopy: (token: string) => void;
  title : string;
}

export function TokenModal(props: TokenModalProps) {
  const { open, onClose, token, onCopy, title } = props;

  return (
    <Modal open={open} aria-labelledby="token-modal-title">
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: '90%', sm: '80%', md: 800 },
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2
        }}>
         <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography variant="body1">{title}</Typography>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Tooltip title="Copy to clipboard">
          <IconButton onClick={() => onCopy(token)}>
            <ContentCopyIcon />
          </IconButton>
        </Tooltip>
          </Box>
        </Box>
        <TextField
          fullWidth
          multiline
          value={token}
          variant="outlined"
          InputProps={{
            readOnly: true
          }}
        />
        <Button variant="contained" color="primary" fullWidth sx={{ mt: 2 }} onClick={onClose}>
          Close
        </Button>
      </Box>
    </Modal>
  );
}
